
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';

const Addclient = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        client: '',
        subclient:'',
        costcenter:'',
        budgethours:0,
        projectid:''
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const roledata = localStorage.getItem('role') != '' ? JSON.parse(localStorage.getItem('role')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [clientenabled, setclientstatus] = useState(false);
    const [projectChange, setProjectChange] = useState({isproject:'no',projectid:''});
    
     
    const [formData2, setForm2Data] = useState({
        selectedclient: '',
        selectedsubclient: '',
        task:'',
        minutes:'',
        billedminutes:'',
        budgethours:'',
        remainingbudgethours:'',
        count:'',
        fillingfor:'',
        remarks:''
      });
     
    useEffect(()=>{
        getallclient();
        _getproject();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));


            if(name == 'projectid'){
                // get client data
                setProjectChange({isproject:'yes',projectid:value});  
            }
    
            if(name == 'client'){
                allclientandsubclient(value);
                
            }
            if(name == 'subclient'){
                    let _userdatalist = datacomptemp;
                    const searchRegexClient    = new RegExp(formData.client.toLowerCase());
                    const searchRegexSubclient = new RegExp(value.toLowerCase());
                    const foundItems = _userdatalist.filter(item => 
                    //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                     (searchRegexClient.test(item.client.toLowerCase()) && searchRegexSubclient.test(item.subclient.toLowerCase()))
                    );
                  
                    if (foundItems.length > 0) {
                        console.log('items found.');
                        setDatacomp(foundItems);
                    } else {
                        console.log('No items found.');
                        setDatacomp([]);
                    }
                  
                // let subclientval = JSON.parse(value);
                // setFormData((prevData)=>({...prevData,budgethours:subclientval.budget_hours}));
            }
        }catch(e){
            console.log(e);
        }
        
    };

    function allclientandsubclient(valuedata){
        let emparr = [];
        setloading(false);
        let value = valuedata;
        timesheetService.allclientandsubclient(value,{projectid:projectChange.projectid}).then((response)=>{
            if(response.status == 200){
                setloading(true);
                setDatacomp(response.data.data);
                setDatacomptemp(response.data.data);
                
                let odatalength = response.data.data.length;
                let allowedarr = [];
                response.data.data.forEach((values,index)=>{
                     if(values.client_allowed == 'allowed'){
                        allowedarr.push(values.client_allowed);
                     }
                });

                if(allowedarr.length == odatalength){
                     setclientstatus(true);
                }else{
                     setclientstatus(false);
                }

            }else{
                setDatacomp([]);
                setDatacomptemp([]);
                setloading(true);
                setclientstatus(false);
            }
        }).catch((error)=>{
            setDatacomp([]);
            setDatacomptemp([]);
            setloading(true);  
        });
    }

    function subclientpower(e,id){
         let data = {
            'eval':e.value,
            'id':id
         };
         data = JSON.stringify(data);
         timesheetService.update_enabledclient({formdata:data}).then((response)=>{
             if(response.status == 200){
                allclientandsubclient(formData.client);
             }else{
                 
             }
         }).catch((error)=>{

         });
    }

    function clientdisplay(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            // console.log(value.name);
            let checked = false;
            if(value.allowed == 'allowed'){
                checked = true; 
            }else{
                checked = false; 
            }

            emparr.push(<tr>
                 <td>{value.id}</td>
                 <td>{value.client}</td>
                 <td>{value.subclient}</td>
                 <td>{value.costcenter}</td>
                 <td><ToggleButton checked={checked} onChange={(e)=> subclientpower(e,value.id)} onLabel="ON" offLabel="OFF" onIcon="" offIcon="fa fa-cancel" className="w-8rem" /></td>
            </tr>);
        }); 

        return emparr;
    }

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.client == '') {
          newErrors.client = 'Client name is required';
          valid = false;
        }

        if (formData.subclient == '') {
            newErrors.subclient = 'Subclient name is required';
            valid = false;
        }
        setErrors(newErrors);
        return valid; 
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
             return;  
        }
        try{
            let obj ={
                'client':formData.client,
                'subclient':formData.subclient,
                'costcenter':formData.costcenter,
                'projectid':formData.projectid
            }; 
            obj = JSON.stringify(obj);
            setloading(false);
            timesheetService.addclient({formdata:obj}).then((response)=>{
                console.log(response);
                if(response.status == 200){
                    toast.current.show({severity:'success', summary: "Client", detail:`Client updated successfully!`, life: 3000});
                    setloading(true);
                    allclientandsubclient(formData.client);
                }else{
                    toast.current.show({severity:'error', summary: "Client", detail:`${response.data.data}`, life: 3000});  
                    setloading(true); 
                }
            }).catch((error)=>{
                toast.current.show({severity:'error', summary: "Client", detail:`Error`, life: 3000}); 
                setloading(true); 
            });
        }catch(e){
           console.log(e);
           setloading(true);
        }
    };

    function getbudgethours(){
        let emparr = [];
        setloading(false);
        adminService.getbudgethours().then((response)=>{
            
            setloading(true);
            setDatastate(true);
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });   
    }

    function getallclient(){
        // projectChange.projectid;
        // projectChange.isproject;
        let emparr = [];
        let selecteddata = projectChange.projectid != '' ? projectChange.projectid : 'all';
        
        timesheetreportService.getclientslistmanager('all',{projectid:selecteddata}).then((response)=>{
            console.log(response);
            let tempclients = [];
            response.data.data.forEach((value,index) =>{
                if(value.client != ''){
                    emparr.push(<option value={value.client}>{value.client}</option>);
                }
            });
            // setClientlists(tempclients);
            setClientcomp(emparr);
         }).catch((error)=>{
            setClientcomp([]);
         }); 
    

        // adminService.getallclient().then((response)=>{
        //    console.log(response.data.data);
        //    response.data.data.forEach((value,index)=>{
        //     if(value.client != ''){
        //         emparr.push(<option value={value.client}>{value.client}</option>);
        //     }
           
        //    });
        //    setClientcomp(emparr);
        // }).catch((error)=>{
        //    console.log(error);  
        // });   
    }

    function toggleclientstatus(e){ 
        console.log(e.target.value);
        let status = e.target.value;
        let client = formData.client;
        timesheetService.toggleclientstatus(client,status).then((response)=>{
           if(response.status == 200){

               setclientstatus(status); 
            //    console.log(response);
           }else{
            //    setclientstatus(true); 
           }
        }).catch((error)=>{
            console.log(error);
            setclientstatus(false);
        })
    }

    function _getproject(){
        let emparr = [];
        setloading(false);

        adminService.getproject().then((response)=>{
           console.log('response'); 
        //    console.log(response.data.data); 
           response.data.data.forEach((value,index)=>{
             console.log(value.name);
             emparr.push(<option value={value.id}>{value.name}</option>);
           });
           setProjcomp(emparr);
        //    setDatacomp([]);
           setloading(true);
           setDatastate(true);
        //    const [datacomp,setDatacomp] = useState([]); 
        }).catch((error)=>{
            setloading(true);
            setDatastate(true);
        });
    } 


    useEffect(()=>{
        if(projectChange.isproject == 'yes'){
            //  console.log(projectChange.projectid);
            //  console.log("project changed");   
             getallclient();        
        }
    },[projectChange]);       

 return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
            <Toast ref={toast} />

              {roledata.rolename == 'superadmin'  ? <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-4'>
                <div className='row'>
                     <div className='col-md-12'>
                        <Message severity="error" text="Note :
When adding a new subclient, please ensure that both the client and subclient names are not duplicated. Before adding a subclient, check if a subclient with the same name already exists and avoid duplicates." />
                     
                     </div> 
                   {/* <div className="col-md-12">
                     <br/>
                        <label className='pull-left'>Select Project</label>
                        <br/>
                        <select className='custom-dropdown-style' name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Project</option>
                           {projcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div> */}

                   <div className="col-md-12">
                     <br/>
                        <label className='pull-left'>Select Project</label>
                        <br/>
                        <select className='custom-dropdown-style' required  name="projectid" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Project</option>
                           {projcomp}
                        </select>
                        {/* {errors.projname && <span className='error'>{errors.projname}</span>} */}
                    </div>     

                   <div className="col-md-12">
                   <br/>
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           {clientcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    
                    <div className="col-md-12">
                    <br/>
                        <label className='pull-left'>Sub-client</label>
                        <br/>
                        <input type='text' value={formData.subclient} name='subclient' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div>

                    <div className="col-md-12">
                    <br/>
                        <label className='pull-left'>Costcenter</label>
                        <br/>
                        <input type='text' value={formData.costcenter} name='costcenter' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {/* {errors.subclient && <span className='error'>{errors.subclient}</span>} */}
                    </div>
                    
                    <div className="col-md-12 col-sm-12">
                       <br/>
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />
                        </div>
                     </div>
                </div>
                <br/>
                <br/>
               
                </div>
                <div className='col-md-8'>
                     <div className='col-md-12'>
                        {formData.client != '' ? (<ToggleButton checked={clientenabled} onChange={(e) => toggleclientstatus(e)} onLabel="ON" offLabel="OFF" onIcon="" offIcon="fa fa-cancel" className="w-8rem float-left" />  ) : (<></>)}
                        <Message severity="error" text="To disable the client please toggle this button" />
                     </div>  

                     <div className='divider'></div>

                     <br/> 

                     <div className='col-md-12'>
                        <Message style={{width:'100%'}} severity="info" text="To disable the Subclient please select client from below Client lists" />
                     </div>

                     
                    <div className='col-md-12'>
                    <br/>
                    {!isloaded ? loader.Loadermd() : datacomp.length > 0 ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col">Subclient</th>
                                <th scope="col">Cost center</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientdisplay()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                </div>
                </div>
                </form> : (<form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-4'>
                <div className='row'>
                     <div className='col-md-12'>
                        <Message severity="error" text="Note :
When adding a new subclient, please ensure that both the client and subclient names are not duplicated. Before adding a subclient, check if a subclient with the same name already exists and avoid duplicates." />
                     
                     </div> 
                   {/* <div className="col-md-12">
                     <br/>
                        <label className='pull-left'>Select Project</label>
                        <br/>
                        <select className='custom-dropdown-style' name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Project</option>
                           {projcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div> */}
                   <div className="col-md-12">
                   <br/>
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           {clientcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    
                    <div className="col-md-12">
                    <br/>
                        <label className='pull-left'>Sub-client</label>
                        <br/>
                        <input type='text' value={formData.subclient} name='subclient' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {errors.subclient && <span className='error'>{errors.subclient}</span>}
                    </div>

                    <div className="col-md-12">
                    <br/>
                        <label className='pull-left'>Costcenter</label>
                        <br/>
                        <input type='text' value={formData.costcenter} name='costcenter' onChange={(e)=>handleChange(e)} className='form-control'/>
                        {/* {errors.subclient && <span className='error'>{errors.subclient}</span>} */}
                    </div>
                    
                    <div className="col-md-12 col-sm-12">
                       <br/>
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />
                        </div>
                     </div>
                </div>
                <br/>
                <br/>
               
                </div>
                <div className='col-md-8'>
                     <div className='col-md-12'>
                        {formData.client != '' ? (<ToggleButton checked={clientenabled} onChange={(e) => toggleclientstatus(e)} onLabel="ON" offLabel="OFF" onIcon="" offIcon="fa fa-cancel" className="w-8rem float-left" />  ) : (<></>)}
                        <Message severity="error" text="To disable the client please toggle this button" />
                     </div>  

                     <div className='divider'></div>

                     <br/> 

                     <div className='col-md-12'>
                        <Message style={{width:'100%'}} severity="info" text="To disable the Subclient please select client from below Client lists" />
                     </div>

                     
                    <div className='col-md-12'>
                    <br/>
                    {!isloaded ? loader.Loadermd() : datacomp.length > 0 ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col">Subclient</th>
                                <th scope="col">Cost center</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientdisplay()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                </div>
                </div>
                </form>) }
               
              
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                   
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Addclient;
